import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const policyReviewPage = PageBlueprint.make({
  params: {
    path: '/policy-review',
    noHeader: true,
    loader: () =>
      import('./components/PolicyReviewPage').then(m => (
        <PageErrorBoundary title="Policy review">
          <m.PolicyReviewPage />
        </PageErrorBoundary>
      )),
  },
});

const policyLibraryPage = PageBlueprint.make({
  name: 'library',
  params: {
    path: '/policy-library',
    noHeader: true,
    loader: () =>
      import('./components/PolicyLibraryPage').then(m => (
        <PageErrorBoundary title="The policy library">
          <m.PolicyLibraryPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-policy-review',
  extensions: [policyReviewPage, policyLibraryPage],
});
